module.exports = __webpack_public_path__ + "img/bigLogo.3a83a2d1.gif";